import { useTranslation } from "react-i18next";

import { ICON_DEFAULT_STYLE } from "@/shared/constants";

import {
  CheckIcon,
  HourglassIcon,
  RemoveCircleIcon,
  WarningIcon
} from "@dotnet/telematics-design-system";

import Badge from "../../../components/Badge/Badge";
import { useCompanyCardDetails } from "../../../components/DetailsSection/components/DetailsContent/hooks";
import { COMPANY_CARD_EXPIRY_STATUS } from "../../types";

interface ExpiryBadgeProps {
  color: COMPANY_CARD_EXPIRY_STATUS;
  children: string;
  date?: string;
  tooltip?: string;
  tooltipSize?: "small" | "medium" | "large";
}

const ExpiryBadge = ({
  color,
  children,
  date,
  tooltip,
  tooltipSize
}: ExpiryBadgeProps) => {
  const { isEqual } = useCompanyCardDetails();
  const { t } = useTranslation();

  const tooltipText = isEqual(color, "critical")
    ? t("Company cards##card expired", { date: date })
    : t("Company cards##expiry date", { date: date });

  const renderLeftIcon = () => {
    switch (color) {
      case "success":
        return <CheckIcon style={ICON_DEFAULT_STYLE} />;
      case "info":
        return <HourglassIcon style={ICON_DEFAULT_STYLE} />;
      case "warning":
        return <WarningIcon style={ICON_DEFAULT_STYLE} />;
      case "critical":
        return <RemoveCircleIcon style={ICON_DEFAULT_STYLE} />;
      default:
        return <></>;
    }
  };

  return (
    <Badge
      color={color}
      inverted={false}
      tooltipText={tooltip || tooltipText}
      tooltipSize={tooltipSize || "medium"}
      iconLeft={renderLeftIcon()}
    >
      {children}
    </Badge>
  );
};

export default ExpiryBadge;
